(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-gwp-javascript"] && !Shopify.designMode) return;
  try {
    class CartGWP extends HTMLElement {
    constructor() {
      super();

      this.giftItems = this.querySelectorAll('[data-gwp-item]');
      this.lineItems = document.querySelector('.Cart__ItemList');
      if (this.lineItems) this.removeBtns = this.lineItems.querySelectorAll('[data-action="remove-item"]');

      this.listeners();
    }

    listeners() {
      this.giftItems?.forEach(item => {
        const addToCartButton = item.querySelector('a');

        if (addToCartButton) {
          addToCartButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.addToCart(item);
          });
        }
      });

      this.removeBtns?.forEach(btn => {
        const variantId = btn.getAttribute('data-line-id').split(':')[0];
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.removeDiscountCode(variantId);
        });
      });
    } 

    addToCart(product) {
      const variantId = product.getAttribute('data-variant-id');
      const discountCode = product.querySelector('a').getAttribute('data-discount');

      const formData = {
        items: [
          {
            quantity: 1,
            id: variantId,
          }
        ]
      }

      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      fetch(window.routes.cartAddUrl + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        this.updateCartWithDiscount(discountCode, variantId)
      })
    }

    updateCartWithDiscount(discountCode, variantId) {
      const formData = {
        discount: discountCode
      }
      
      fetch(window.routes.cartUrl + '/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        this.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: variantId,
            quantity: 1
          }
        }));
      });
    }

    removeDiscountCode(variantId) {
      const updates = {
        variantId: 0
      }

      fetch(window.routes.cartUrl + '/update.js', {
        method: 'POST', 
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates,
          discount: ''
        })
      })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      })
    }
  }

  customElements.define('cart-gwp', CartGWP);
  } catch(e) { console.error(e); }
})();

})();
